import { Injectable } from '@angular/core';

import { Status } from '@enums';
import { BankingDetails } from '@models';
import { CrudService, HttpService } from '@services';
import { environment } from '../../../environment/environment';

@Injectable({ providedIn: 'root' })
export class BankingDetailsService extends CrudService<BankingDetails> {
  constructor(http: HttpService) {
    super('banking-details', http);
  }

  async setBankingDetailsStatus(
    bankingDetails: BankingDetails,
    status: Status
  ): Promise<BankingDetails> {
    const endpoint = `${environment.apiUrl}/banking-details/status`;
    const response = await this.http.post<BankingDetails>(endpoint, {
      bankingDetailsId: bankingDetails.id,
      status,
    });

    if (!response.success) throw new Error(response.message);
    return response.data;
  }
}
